// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 801 ? "2d4dc074" : chunkId) + "." + {"801":"4f6f1ef899a745e0","848":"e969341f5d932c64","945":"d75e13f5cb93209d"}[chunkId] + ".js";
};